var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaQs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FAQs_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FAQs"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.1,40.8c5.7,5.1,8.5,12.2,8.5,21.2c0,9.8-3,17.2-9.1,22.1c-6.1,5-14.4,7.5-24.8,7.7v15.6H68.3V81.1h6.8 c8.2,0,14.7-1.3,19.4-4c4.7-2.7,7.1-7.7,7.1-14.9c0-4.9-1.4-8.7-4.2-11.5c-2.8-2.8-6.7-4.2-11.5-4.2c-5.1,0-9.2,1.5-12.3,4.4 c-3.1,2.9-4.7,6.7-4.7,11.5H53.5c-0.1-5.7,1.2-10.7,3.8-15.1s6.5-7.8,11.5-10.3s10.9-3.7,17.7-3.7 C95.9,33.1,103.4,35.7,109.1,40.8z M85.3,120v17.8H66.9V120H85.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/FAQs.739d34c6c2e5d2d37ae29c02c34dd2cd.svg";
export { ForwardRef as ReactComponent };